import { render } from "./CallWin.vue?vue&type=template&id=132712af"
import script from "./CallWin.vue?vue&type=script&lang=js"
export * from "./CallWin.vue?vue&type=script&lang=js"

import "./CallWin.vue?vue&type=style&index=0&id=132712af&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__